<template>
  <el-dialog custom-class="max-dialog1256" title="自动发放规则" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <el-col :span="24" class="toobar">
      <el-col :span="5">
        <el-radio-group v-model="certtype" @change="bindGrid">
          <el-radio-button :label="'16'" :key="'16'">客户</el-radio-button>
          <el-radio-button :label="'17'" :key="'17'">商品</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-col>
    <el-col v-if="certtype=='16'">
      <el-row :gutter="20">
        <el-button type="warning" style="margin-right: 10px;float: right" v-on:click="uploadgoods" size="mini">导入</el-button>
        <input type="file" ref="fileupload" style="display: none;" @change="change1($event)"/>
        <el-button type="primary" style="margin-right: 10px;float: right" size="mini" @click="showDeptDetailSel">选择客户</el-button>
        <el-table
          :data="goodsData.filter(data => !searchdept || data.seedname.toLowerCase().includes(searchdept.toLowerCase()))"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column
            width="60"
            label="序号"
            align="center">
            <template slot-scope="scope">
              {{1+scope.$index}}
            </template>
          </el-table-column>
          <el-table-column
            prop="seedcode"  width="200"
            label="客户编码"
            align="left"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="seedname"
            label="客户名称"
            align="left"
            header-align="center">
            <template slot="header" slot-scope="scope">
              <el-input
                v-model="searchdept"
                size="mini"
                placeholder="输入关键字搜索"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="scope">
              <a
                size="mini" href="javascript:void(0)" style="color:#20A0FF;"
                type="danger"
                @click="goodsDelete(scope.$index, scope.row)">删除
              </a>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-col>
    <el-col v-if="certtype=='17'">
        <el-row :gutter="20">
          <el-button type="primary" style="margin-right: 10px;float: right" size="mini" @click="showGoodDetailSel">选择商品</el-button>
          <el-table
            :data="goodsData.filter(data => !searchgood || data.seedname.toLowerCase().includes(searchgood.toLowerCase()))"
            size="mini"
            stripe
            border
            style="width: 100%;">
            <el-table-column
              width="60"
              label="序号"
              align="center">
              <template slot-scope="scope">
                {{1+scope.$index}}
              </template>
            </el-table-column>
            <el-table-column
              prop="categoryname"
              label="产品类别"
              align="left"
              header-align="center"
              width="170">
              <template slot-scope="scope">
                {{!scope.row.seedcode?scope.row.categorycode+' '+scope.row.categoryname:scope.row.categoryname}}
              </template>
            </el-table-column>
            <el-table-column
              prop="seedname"
              label="产品名称"
              align="left"
              header-align="center">
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="searchgood"
                  size="mini"
                  placeholder="输入关键字搜索"/>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="80">
              <template slot-scope="scope">
                <a
                  size="mini" href="javascript:void(0)" style="color:#20A0FF;"
                  type="danger"
                  @click="goodsDelete(scope.$index, scope.row)">删除
                </a>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
    </el-col>
    <JxcgooddetailSel ref="JxcgooddetailSel" :isShowCheckBox="true"  @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
    <ExternaldeptMulSel ref="ExternaldeptMulSel" @afterSelectCode="afterSelectDept"></ExternaldeptMulSel>
  </el-dialog>
</template>


<script>
  import {getListData,saveData,deleteData} from '@/api/set/accountageset';
  import JxcgooddetailSel from '../../set/jxcgooddetail/JxcgooddetailSel';
  import ExternaldeptMulSel from '../../set/externaldept/ExternaldeptMulSel';
  export default {
    name: "Automatic",
    data() {
      return {
        certtype:'16',
        searchdept:'',
        searchgood:'',
        dialogFormVisible: false,
        goodsData:[],
        salecoupon:{},
      }
    },
    methods: {
      //显示商品选择页面
      showGoodDetailSel() {
        this.$refs.JxcgooddetailSel.show()
      },
      uploadgoods() {
          this.$refs.fileupload.value = ""
          this.$refs.fileupload.click()
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array) && data.length > 0) {
              var loaddata=[];
              for (let i in data) {
                if (!data[i]["客户编码"]) {
                  this.$message.error("客户编码必填！")
                  return;
                }
                if (!data[i]["客户名称"]) {
                  this.$message.error("客户名称必填！")
                  return;
                }
                loaddata.push({
                  lname: '',
                  seedcode: data[i]["客户编码"],
                  seedname: data[i]["客户名称"],
                  categorycode: ''
                });
              }
              this.afterSelectCode(loaddata);
            }
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      showDeptDetailSel(){
        this.$refs.ExternaldeptMulSel.show()
      },
      afterSelectDept(arr){
        if(arr.length==0) return;
        var arrDept=[];
        for(let i in arr){
          arrDept.push({
            lname: '',
            seedcode: arr[i].customerserial,
            seedname: arr[i].customername,
            categorycode: ''
          });
        }
        this.afterSelectCode(arrDept);
      },
      //选择商品之后执行
      afterSelectCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        var sData=[];
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.goodsData) {
            if (this.goodsData[j].seedcode == arr[i].seedcode) {
              biaoji = 1
              count++;
              break
            }
          }
          if (biaoji == 0) {
            sData.push({
              setmethod: this.certtype,
              categoryname: arr[i].lname,
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              categorycode: arr[i].categorycode
            });
          }
        }
        if(sData.length>0){
          saveData({customerserial:this.salecoupon.unitguid,detail:JSON.stringify(sData)}).then(response=>{
            this.$message({
              type: 'success',
              message: '保存成功!'
            });
            this.bindGrid();
          })
        }
        // if (count > 0) {
        //   this.$message({
        //     message: "商品已存在！",
        //     type: 'info'
        //   })
        // }
      },
      goodsDelete(index,row){
        var delGuid=[];
        delGuid.push(row.unitguid);
        saveData({customerserial:this.salecoupon.unitguid,delunitguids:JSON.stringify(delGuid),detail:JSON.stringify([])}).then(response=>{
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.goodsData.splice(index, 1)
        })
      },
      customerChange(value, direction, movedKeys) {
        if (movedKeys.length == 0) {
          this.$message({
            type: 'error',
            message: '请选择客户!'
          });
          this.loading=false
        } else {
          this.form.customerserials = movedKeys.toString();
        }
      },
      bindGrid() {
        getListData({customerserial: this.salecoupon.unitguid, setmethod: this.certtype}).then(response => {//商品编码
          this.goodsData = response.data.obj;
        });
      },
      initdata(row) {
        this.salecoupon=row;
        this.certtype='16';
        this.dialogFormVisible = true;
        this.bindGrid();
      },
      initForm(unitguid, storeInfo) {
        this.loading=false
        this.bindGrid();
      },
      clearCustomerName(){
        this.form.customerserials = '';
        this.form.customername = '';
      },
      selectExternalDept(customerserial, deptname, row) {
        this.form.customerserials = customerserial;
        this.form.customername = deptname;
      },
      handleChange(value) {
        this.form.count = value
      },
    },
    mounted() {
    },
    components: {
      JxcgooddetailSel,
      ExternaldeptMulSel
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/set/salefavour/Automatic.vue